import React from "react";
import PropTypes from "prop-types";
import {
  Card,
  ContentWrapper,
  LeftSection,
  RightSection,
  Label,
  Heading,
  Checklist,
  ChecklistItem,
  IconWrap,
  ChecklistText,
  IconContainer,
} from "./SurmountAccountCard.styles.js";
import {
  CreateSurmountAccountIcon,
  CheckVerifiedIcon,
} from "assets/icons/index";

const SurmountAccountCard = ({
  onClick,
  selected = false,
  showLabel = true,
  heading = "Create Your Surmount Account",
  isPending = false,
}) => {
  const accountFeatures = [
    "Secure, compliant trading",
    "Instant deposits & withdrawals",
    "Real-time performance tracking",
    "Automate your investment strategies",
  ];

  const displayHeading = isPending
    ? "Your Surmount Account is Pending"
    : heading;

  return (
    <Card onClick={onClick} className={selected ? "selected" : ""}>
      {showLabel && <Label>{!isPending ? "Recommended" : "Pending"}</Label>}
      <ContentWrapper>
        <LeftSection>
          <Heading>{displayHeading}</Heading>
          <Checklist>
            {accountFeatures.map((text) => (
              <ChecklistItem key={text}>
                <IconWrap>
                  <img src={CheckVerifiedIcon} alt="Check Verified" />
                </IconWrap>
                <ChecklistText>{text}</ChecklistText>
              </ChecklistItem>
            ))}
          </Checklist>
        </LeftSection>
        <RightSection>
          <IconContainer>
            <CreateSurmountAccountIcon />
          </IconContainer>
        </RightSection>
      </ContentWrapper>
    </Card>
  );
};

SurmountAccountCard.propTypes = {
  onClick: PropTypes.func,
  selected: PropTypes.bool,
  showLabel: PropTypes.bool,
  heading: PropTypes.string,
  isPending: PropTypes.bool,
};

export default SurmountAccountCard;
